/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UsageChooser/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSuperSelect from 'DesignSystem/TysiaSuperSelect/index'
import TysiaSuperSelectContent from 'DesignSystem/TysiaSuperSelect/TysiaSuperSelectContent/index'
import TysiaSuperSelectField from 'DesignSystem/TysiaSuperSelect/TysiaSuperSelectField/index'
import TysiaSuperSelectValues from 'DesignSystem/TysiaSuperSelect/TysiaSuperSelectValues/index'



/** @type {import('Simple/types.js').View} */
export default function UsageChooser({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/NoteTemplates/Template/Usage/UsageChooser",
  onChange
  
}) {
let usageAreasValueData = fromData.useDataValue({ viewPath,
context: 'usage_areas',
})
let noteTemplateUsedInValueData = fromData.useDataValue({ viewPath,
context: 'note_template',
path: 'used_in',
})
let noteTemplateUsedInChangeData = fromData.useDataChange({ viewPath,
context: 'note_template',
path: 'used_in',
})
  return (<React.Fragment
>
<TysiaSuperSelect
  viewPath={`${viewPath}/TysiaSuperSelect`}
 size="small"
 marginTop={0}
 data="usage_areas"
 from={usageAreasValueData}
 data="note_template.used_in"
 value={noteTemplateUsedInValueData}
 onChange={noteTemplateUsedInChangeData}
 placeholder="Select areas where this template will be used"
>
{childProps => (
<React.Fragment>
<TysiaSuperSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSuperSelectContent`}
>
{childProps => (
<TysiaSuperSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSuperSelectField`}
/>
)}
</TysiaSuperSelectContent>
<TysiaSuperSelectValues
{...childProps}
  viewPath={`${viewPath}/TysiaSuperSelectValues`}
/>
</React.Fragment>
)}
</TysiaSuperSelect>
{children}
</React.Fragment>)
}